import { createBrowserHistory } from 'history';

export default createBrowserHistory({
    // optional configuration object here
});



// WEBPACK FOOTER //
// ./src/providers/history.ts